import { v0 } from 'src/reducers/migrations/v0';
import { v1 } from 'src/reducers/migrations/v1';
import { v10 } from 'src/reducers/migrations/v10';
import { v11 } from 'src/reducers/migrations/v11';
import { v12 } from 'src/reducers/migrations/v12';
import { v13 } from 'src/reducers/migrations/v13';
import { v14 } from 'src/reducers/migrations/v14';
import { v15 } from 'src/reducers/migrations/v15';
import { v16 } from 'src/reducers/migrations/v16';
import { v17 } from 'src/reducers/migrations/v17';
import { v18 } from 'src/reducers/migrations/v18';
import { v19 } from 'src/reducers/migrations/v19';
import { v2 } from 'src/reducers/migrations/v2';
import { v20 } from 'src/reducers/migrations/v20';
import { v21 } from 'src/reducers/migrations/v21';
import { v22 } from 'src/reducers/migrations/v22';
import { v23 } from 'src/reducers/migrations/v23';
import { v24 } from 'src/reducers/migrations/v24';
import { v25 } from 'src/reducers/migrations/v25';
import { v26 } from 'src/reducers/migrations/v26';
import { v27 } from 'src/reducers/migrations/v27';
import { v28 } from 'src/reducers/migrations/v28';
import { v29 } from 'src/reducers/migrations/v29';
import { v3 } from 'src/reducers/migrations/v3';
import { v30 } from 'src/reducers/migrations/v30';
import { v31 } from 'src/reducers/migrations/v31';
import { v32 } from 'src/reducers/migrations/v32';
import { v33 } from 'src/reducers/migrations/v33';
import { v34 } from 'src/reducers/migrations/v34';
import { v35 } from 'src/reducers/migrations/v35';
import { v36 } from 'src/reducers/migrations/v36';
import { v37 } from 'src/reducers/migrations/v37';
import { v38 } from 'src/reducers/migrations/v38';
import { v39 } from 'src/reducers/migrations/v39';
import { v4 } from 'src/reducers/migrations/v4';
import { v40 } from 'src/reducers/migrations/v40';
import { v41 } from 'src/reducers/migrations/v41';
import { v42 } from 'src/reducers/migrations/v42';
import { v43 } from 'src/reducers/migrations/v43';
import { v44 } from 'src/reducers/migrations/v44';
import { v45 } from 'src/reducers/migrations/v45';
import { v46 } from 'src/reducers/migrations/v46';
import { v47 } from 'src/reducers/migrations/v47';
import { v48 } from 'src/reducers/migrations/v48';
import { v49 } from 'src/reducers/migrations/v49';
import { v5 } from 'src/reducers/migrations/v5';
import { v50 } from 'src/reducers/migrations/v50';
import { v51 } from 'src/reducers/migrations/v51';
import { v52 } from 'src/reducers/migrations/v52';
import { v6 } from 'src/reducers/migrations/v6';
import { v7 } from 'src/reducers/migrations/v7';
import { v8 } from 'src/reducers/migrations/v8';
import { v9 } from 'src/reducers/migrations/v9';
import { ReduxState } from 'src/store/types';

export const CURRENT_MIGRATION_VERSION = 52;

// input state must be typed as `any` since it's an older version of the Redux State
export const MIGRATION_MANIFEST: Record<number, (state: any) => ReduxState> = {
  0: v0,
  1: v1,
  2: v2,
  3: v3,
  4: v4,
  5: v5,
  6: v6,
  7: v7,
  8: v8,
  9: v9,
  10: v10,
  11: v11,
  12: v12,
  13: v13,
  14: v14,
  15: v15,
  16: v16,
  17: v17,
  18: v18,
  19: v19,
  20: v20,
  21: v21,
  22: v22,
  23: v23,
  24: v24,
  25: v25,
  26: v26,
  27: v27,
  28: v28,
  29: v29,
  30: v30,
  31: v31,
  32: v32,
  33: v33,
  34: v34,
  35: v35,
  36: v36,
  37: v37,
  38: v38,
  39: v39,
  40: v40,
  41: v41,
  42: v42,
  43: v43,
  44: v44,
  45: v45,
  46: v46,
  47: v47,
  48: v48,
  49: v49,
  50: v50,
  51: v51,
  52: v52,
};
